/** Зона у края viewport (screen px), в которой включается авто-пан. */
export const EDGE_PAN_ZONE_PX = 40;
/** Макс. скорость камеры: px за 16ms при полном погружении в зону. */
export const EDGE_PAN_MAX_SPEED = 14;

export type EdgePanRect = {
  left: number;
  top: number;
  right: number;
  bottom: number;
};

/**
 * Смещение камеры (screen px) за кадр, если курсор у края viewport.
 * Знак pan: у правого/нижнего края уменьшаем panX/panY — открывается дальняя часть доски.
 */
export function edgePanDelta(
  clientX: number,
  clientY: number,
  rect: EdgePanRect,
  frameDtMs: number
): { dx: number; dy: number; active: boolean } {
  const zone = EDGE_PAN_ZONE_PX;
  const dt = Math.min(34, Math.max(0, frameDtMs));
  const speedScale = (EDGE_PAN_MAX_SPEED * dt) / 16;

  let vx = 0;
  let vy = 0;

  const fromLeft = clientX - rect.left;
  const fromRight = rect.right - clientX;
  const fromTop = clientY - rect.top;
  const fromBottom = rect.bottom - clientY;

  if (fromLeft < zone) {
    vx += (1 - clamp01(fromLeft / zone)) * speedScale;
  }
  if (fromRight < zone) {
    vx -= (1 - clamp01(fromRight / zone)) * speedScale;
  }
  if (fromTop < zone) {
    vy += (1 - clamp01(fromTop / zone)) * speedScale;
  }
  if (fromBottom < zone) {
    vy -= (1 - clamp01(fromBottom / zone)) * speedScale;
  }

  const active = Math.abs(vx) > 0.05 || Math.abs(vy) > 0.05;
  return { dx: vx, dy: vy, active };
}

function clamp01(n: number): number {
  if (n <= 0) return 0;
  if (n >= 1) return 1;
  return n;
}

export function isNearViewportEdge(
  clientX: number,
  clientY: number,
  rect: EdgePanRect,
  zone = EDGE_PAN_ZONE_PX
): boolean {
  return (
    clientX - rect.left < zone ||
    rect.right - clientX < zone ||
    clientY - rect.top < zone ||
    rect.bottom - clientY < zone
  );
}
